import { IState } from 'legacy/lut/store'

export const selectMasterDealerData = (state: IState) => state.masterDealerData
